import React from 'react'
import HeaderWrapper from 'pages/documentscontent/HeaderWrapper'
import PrecedentsContentHeaderContainer from 'redux/containers/pages/precedentscontent/PrecedentsContentHeaderContainer'

export default (props) => props.sectionId
  ? <HeaderWrapper {...props} />
  : <PrecedentsContentHeaderContainer {...props} />
